import type { Bank } from "modules/banks";
import type { Order } from "../../../models/helpers";
import type { UUID } from "../../../utils";
import type { BLOCK_RULE_ALL_TYPES } from "../constants";

export type BlockRuleType = typeof BLOCK_RULE_ALL_TYPES[number];

export interface BlockRule {
  id: UUID;
  userId: UUID;
  username?: string; // only in duplicate create response
  customerId: UUID;
  type: BlockRuleType;
  value?: string;
  bank?: Pick<
    Bank,
    "id" | "name" | "active" | "logo" | "icon" | "branchName" | "country"
  >;
  blockedAt: string;
  active: boolean;
}

export type SelectedBlockRule = Pick<BlockRule, "id" | "active">;

export type BlockRulePostBody = Pick<BlockRule, "value" | "type">;

export type BlockRuleActiveState = "yes" | "no";

export const BlockRuleActiveStates: Record<string, BlockRuleActiveState> = {
  YES: "yes",
  NO: "no",
} as const;

export type BlockRulesQueryParams = {
  page: number;
  limit: number;
  orderBy: keyof BlockRule;
  order: Order;
  search: string;
  types: BlockRuleType[];
  active: BlockRuleActiveState[];
  customerId: string;
};

export type BlockRulesFilterParams = Partial<
  Pick<BlockRulesQueryParams, "types" | "active">
>;
